import { DEFAULT_ENTITY_AUTHOR } from 'domain/shared/core/constants';
import { EntityHeader } from 'framework/ui/layout';

/* istanbul ignore file */
const AssignmentEntityHeader = () => {
  return <EntityHeader defaultAuthor={DEFAULT_ENTITY_AUTHOR} entityTitleSource="id" />;
};

export default AssignmentEntityHeader;
